import { MenuListItemProps } from '../../components/menus/features/menu-tab';
import Group from '../../models/groups';
import Membership from '../../models/membership';
import { RootState } from '../../store';
import { PermissionsTabEnum } from '../permissions.slice';

export const memberIdsFromGroups = (selected) => selected.flatMap((group: Group) => group.memberIds);

export default function getListItems(members: Membership[], groups: Group[], ownerRoles: string[]) {
  return (state: RootState): MenuListItemProps[] => {
    const { tab, selectedGroups } = state.permissions;

    if (tab === PermissionsTabEnum.Members) {
      return members.map((member) => ({
        primaryText: `${member.firstName} ${member.lastName}`,
        secondaryText: member.email,
        caption: member.roleName,
        id: member.id,
        isDisabled: ownerRoles?.includes(member.roleName),
        isRestrictive: memberIdsFromGroups(selectedGroups).includes(member.id),
      }));
    }
    if (tab === PermissionsTabEnum.Groups) {
      return groups.map((group) => ({
        primaryText: group.name,
        secondaryText: group.description ?? '',
        caption: `${group.memberIds?.length ?? 0} members`,
        id: group.id,
        isDisabled: false,
        isRestrictive: false,
      }));
    }
    return [];
  };
}
